///////////////////////////////////
// McDonald's Submission Form
///////////////////////////////////

// Schema Arrays Correspond to Form Types as follows:
// [empty,empty,Test LTO, National LTO, Application Requests]

var schema = {
    "name":               [1,1,0,1,0,1,1,1,1,1],
    "custom_id":          [1,1,0,1,0,1,1,1,1,1],
    "start_date":         [1,1,0,1,0,1,1,1,1,1],
    "end_date":           [1,1,0,1,0,1,1,1,1,0],
    "day_parts[]":        [1,1,0,1,0,1,0,0,0,0],
    "linked_subs[]":      [1,1,0,1,0,1,0,0,0,0],
    "stages[]":           [1,1,0,1,0,1,0,0,0,0],
    "kit_name":           [1,1,0,1,0,1,0,0,0,0],
    "product_code[]":     [1,1,0,1,0,1,1,0,0,1],
    "instructions":       [1,1,0,1,0,1,1,1,1,1],
    "promo_types[]":      [1,1,0,1,0,1,0,0,0,0],
    "languages[]":        [1,1,0,1,0,1,1,1,1,1],
    "zones[]":            [0,0,0,0,0,0,1,1,1,1],
    "categories[]":       [0,0,0,0,0,0,1,1,1,1],
    "cells":              [0,0,0,0,0,0,0,1,0,0],
    "project_test":       [0,0,0,0,0,0,0,1,0,0],
    "project_creative[]": [0,0,0,0,0,0,0,0,0,1],
    "all_files":          [0,0,0,0,0,0,1,1,1,1]
};

var fieldOn = function(key) {
  $('[name="'+key+'"]').attr("disabled",false);
  $('[name="'+key+'"]').parent().show();
};

var fieldOff = function(key) {

  $('[name="'+key+'"]').attr("disabled",true);
  $('[name="'+key+'"]').parent().hide();
};

var getFormType = function() {
  return $('#form-type').val() - 1;
};

var toggleFields = function() {
  var formType = getFormType();
  if (formType != -1) {
    $('#submission-submit').show();
  } else {
    $('#submission-submit').hide();
  }

  for (var e in schema) {
    if (schema.hasOwnProperty(e)) {

      if (schema[e][formType] == 0) { // Hide form field if toggled to 0
        fieldOff(e);
      } else if (schema[e][formType] == 1) { // Show form field if toggled to 1
        fieldOn(e);
      } else if (formType == -1) { // Hide All Form Fields at start
        fieldOff(e);
      }
    }
  }
};

var checkBoxTrue = function($this) {
    if ( $this.is(':checked') ) {
        if ($this.hasClass('check-sub') || $this.hasClass('check-sub-modal')){
            $this.val(1);
        }
        if ($this.hasClass('check-sub')){
            $currentId=$this.attr("name").match(/\d+$/);
            $('.check-type[value="'+$currentId+'"]').prop('checked', true);
        }
        if ($this.hasClass('check-sub-modal')){
            $('.check-type-modal').prop('checked', true);
        }
        if ($this.hasClass('check-type')){
            $currentId=$this.attr("value").match(/\d+$/);
            $('.check-sub[name$="'+$currentId+'"]').prop('checked', true);
            $('.check-sub[name$="'+$currentId+'"]').val(1);
        }
        if ($this.hasClass('check-type-modal')){
            $('.check-sub-modal').prop('checked', true);
              $('.check-sub-modal').val(1);
        }
    } else {
          if ($this.hasClass('check-sub') || $this.hasClass('check-sub-modal')){
            $this.val(0);
        }
          if ($this.hasClass('check-type')){
            $currentId=$this.attr("value").match(/\d+$/);
              $('.check-sub[name$="'+$currentId+'"]').prop('checked', false);
              $('.check-sub[name$="'+$currentId+'"]').val(0);
        }
        if ($this.hasClass('check-type-modal')){
            $('.check-sub-modal').prop('checked', false);
              $('.check-sub-modal').val(0);
        }
    }
};

//Enable tabs to use pagination in Laravel
$('.sub_tab').click(function (e) {
    e.preventDefault();
    var thisLi = $(this).closest("li").prop("id");
    if (thisLi == 'notes_tab'){
        $('#revisions').hide();
        $('#notes').show();
    } else {
        $('#revisions').show();
        $('#notes').hide();
    }
    localStorage.setItem('lastTab', thisLi);
});

$(document).ready(function() {

  // Disable Submit buttons after first click
  $('button[type="submit"]').on('click', function(e) {
    e.preventDefault();
    var form = $(this).closest('form');
    $(form).submit();
    $(this).attr('disabled','disabled');
    $(this).text('Sending...');
  });

  // Events for Sort Menu
  $('#sort-button').on('click', function() {
    $('#body-content').toggleClass('shift');
    $('#sort-button').toggleClass('sort-close').toggleClass('btn-primary btn-danger');
  });

  // Action for delete buttons
  $('.delete-button').on('click', function(e) {
    e.preventDefault();
    var response = confirm('Are you sure you want to delete this?');
    if (response == true) {
      $(this).parent().submit();
    }
  });

  // Action for repeatable fields button
  $('.field-repeater').on('click', function(e) {
    e.preventDefault();
    var dupe = $(this).data('duplicate');
    var repeat = $(dupe).first().clone().val('').insertBefore($(this));
  });

  // Initialize Multiselects on Forms
  $('.multi-selectable').multiselect();

  // Toggle Form Fields
  toggleFields();

  $('.check-box').on('change', function(e) {
    checkBoxTrue($(this));
  });

  $('.tooltip-wrapper').tooltip();

    //Enable tabs to use pagination in Laravel
    $('#revisions').hide();
    var lastTab = localStorage.getItem('lastTab');
    if (lastTab) {
        if(lastTab == 'revisions_tab'){
            var otherTab = 'notes_tab';
        } else {
            var otherTab = 'revisions_tab';
        }
        $('#'+lastTab).addClass("active");
        $('#'+otherTab).removeClass("active");
        $('#'+lastTab +' a').trigger("click");
    }

  //On Change of hidden controller field change hidden field of same type
  $('.hidden_controller').on('change', function(e) {
    $input_name_before = "h_"+$(this).attr('name');
    $input_name = $input_name_before.slice(0, -2);
    var $option_all = $(this).find("option:selected").map(function () {
          return $(this).text();
      }).get().join(',');
    $("input[name='"+$input_name+"']").val($option_all);
  }).trigger('change');
  $('.hidden_controller_form').on('change', function(e) {
    $input_name = "h_"+$(this).attr('name');
    var $option_all = $(this).find("option:selected").map(function () {
          return $(this).text();
      }).get().join(',');
    $("input[name='"+$input_name+"']").val($option_all);
  }).trigger('change');
});

$('#form-type').on('change', function() {
  toggleFields();
});
